var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tti-header'),_c('div',{staticClass:"flex justify-center px-4"},[_c('div',{staticClass:"prose prose-sm",domProps:{"innerHTML":_vm._s(_vm.policy)}},[_vm._v(" Loading safeguarding policy… ")])]),_c('tti-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }